import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "DONDRÁE";

// Private / transactional routes we don't want search engines to index.
const NOINDEX_PREFIXES = ["/admin", "/app", "/proposal", "/doc", "/payment", "/connect"];

function titleFor(pathname) {
  if (pathname.startsWith("/admin")) return `Admin · ${SITE}`;
  if (pathname.startsWith("/app")) return `Dashboard · ${SITE}`;
  if (pathname.startsWith("/proposal")) return `Proposal · ${SITE}`;
  if (pathname.startsWith("/doc")) return `Document · ${SITE}`;
  if (pathname.startsWith("/payment")) return `Payment · ${SITE}`;
  if (pathname.startsWith("/connect")) return `Account Setup · ${SITE}`;
  return SITE;
}

export default function RouteSeo() {
  const { pathname } = useLocation();

  // Homepage keeps the rich, crawler-facing tags defined statically in index.html.
  if (pathname === "/" || pathname === "") return null;

  const noindex = NOINDEX_PREFIXES.some((p) => pathname.startsWith(p));
  return (
    <Helmet>
      <title>{titleFor(pathname)}</title>
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
    </Helmet>
  );
}
